/* eslint-disable */
import React from 'react';
import { Button } from '@patternfly/react-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChartTypeDefinition } from '../../../helpers/chart-type.registry';
import './ChartTypeButton.scss';

interface ChartTypeButtonProps {
	definition: ChartTypeDefinition;
	isSelected: boolean;
	onClick: (type: string) => void;
}

export const ChartTypeButton: React.FC<ChartTypeButtonProps> = ({
	definition,
	isSelected,
	onClick,
}) => {
	return (
		<Button
			className={`chart-type-button ${isSelected ? 'selected' : ''}`}
			onClick={() => onClick(definition.type)}
			variant="plain"
			title={definition.label}
		>
			<div className="button-content">
				<FontAwesomeIcon
					icon={definition.icon}
					className="icon"
				/>
				<span className="label">{definition.label}</span>
			</div>
		</Button>
	);
};
